import { ScenarioNameType } from '@/types';

export const colors = {
  primary: '#229CD3',
  mediumBlue: '#245E9D',
  darkBlue: '#00196F',
  darkBlueInactive: '#19307D',
  darkestBlue: '#17244C',
  white: '#FFFFFF',
  offWhite: '#F9F9F9',
  inputColor: '#F0f0f0',
  grey: '#6c6c6c',
  darkGrey: '#4F5055',
  lightGrey: '#DFE0E5',
  teal: '#4FAEA5',
  darkTeal: '#377E86',
  green: '#66BB6A',
  purple: '#7A43B7',
  black: '#000',
  mutedText: '#23242B',
  success: '#189e5d',
  warning: '#fcc203',
  danger: '#eb7434',
  error: '#f01313',
  choroplethExtreme: '#edf8b1',
  choroplethHigh: '#b6e3b6',
  choroplethMed: '#7fcdbb',
  choroplethLow: '#2c7fb8',
};

export const colorMap: Record<ScenarioNameType, string> = {
  'Adaptive Innovation': colors.teal,
  Baseline: colors.black,
  'Business as Usual': colors.darkestBlue,
  'Cooperative Growth': colors.darkTeal,
  'Hot Growth': colors.mediumBlue,
  'Weak Economy': colors.purple,
};
